import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-fee-reports',
  templateUrl: './fee-reports.component.html',
  styleUrls: ['./fee-reports.component.scss'],
})
export class FeeReportsComponent implements OnInit {
  FeeDetailForm: FormGroup;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  feeList: any[] = [];
  filteredfeeList: any[] = [];
  sessionList: any[] = [];
  SessionFilterList: any[] = [];
  FeeData = [];
  filteredcourseList: any[] = [];
  courseList: any[] = [];
  filteredCollegeList: any[] = [];
  collegeList: any[] = [];
  AdmList = false;
  ExmList = false;
  Table = false;
  TotalFees: any;
  TotalPaid: any;
  examList: any[] = [];
  PaidCount: any;
  heads: any = [];
  filteredListExam: any[] = [];
  selectedCourses: string[] = [];
  selectedColleges: string[] = [];
  selectedExams: string[] = [];
  BranchList: any[] = [];
  filteredBranchList: any[] = [];
  BranchShow = false;
  selectedBranches: any[] = [];

  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public datepipe: DatePipe,
    private location: Location,
    private dialog: MatDialog,
    public router: Router
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.AdmList = false;
    this.ExmList = false;
    this.FeeData = [];
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    this.FeeDetailForm = this.fb.group({
      FeeType: new FormControl('', Validators.required),
      SnNo: new FormControl('', Validators.required),
      CgCode: new FormControl([], Validators.required),
      EmId: new FormControl([]),
      CoCode: new FormControl([], Validators.required),
      StrId: new FormControl([]),
    });
    this.fetchFeeType();
    this.fetchSession();
    this.getCourseData();
  }

  fetchFeeType() {
    const payload = {};
    payload['CdType'] = 'FT';
    this.umsService.getCodeType(payload).subscribe(
      (res) => {
        if (res.status) {
          this.feeList = res.data;
          this.filteredfeeList = this.feeList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        // this.spinner.hide();
        let data = {};
        data['message'] = ERROR.error.message;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
    );
  }

  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = '';
    this.umsService.getSession(payload).subscribe((res) => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach((element) => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    });
  }

  fetchBranchesForExams(examIds: string[]) {
    if (!examIds || examIds.length === 0) {
      this.BranchList = [];
      this.filteredBranchList = [];
      this.BranchShow = false;
      this.selectedBranches = [];
      this.FeeDetailForm.patchValue({ StrId: [] });
      return;
    }

    this.spinner.show();
    const requests = examIds.map((emId) => {
      const payload = { EmId: emId };
      return this.umsService.getExamStream(payload).toPromise();
    });

    Promise.all(requests)
      .then((responses) => {
        this.spinner.hide();
        const allBranches: any[] = [];
        responses.forEach((res) => {
          if (res && res.status && res.data) {
            allBranches.push(...res.data);
          }
        });
        // Deduplicate by StrId
        const uniqueBranches = allBranches.filter(
          (branch, index, self) =>
            index === self.findIndex((b) => b.StrId === branch.StrId)
        );
        this.BranchList = uniqueBranches;
        this.filteredBranchList = [...uniqueBranches];
        this.BranchShow = uniqueBranches.length > 0;
        this.selectedBranches = [];
        this.FeeDetailForm.patchValue({ StrId: [] });
      })
      .catch((error) => {
        this.spinner.hide();
        this.BranchList = [];
        this.filteredBranchList = [];
        this.BranchShow = false;
        this.selectedBranches = [];
        this.FeeDetailForm.patchValue({ StrId: [] });
        console.error('Error fetching branches:', error);
      });
  }
  selectAllBranches(): void {
    if (this.isAllBranchesSelected()) {
      this.selectedBranches = [];
      this.FeeDetailForm.get('StrId').setValue([], { emitEvent: false });
    } else {
      this.selectedBranches = this.filteredBranchList.map((item) => item.StrId);
      this.FeeDetailForm.get('StrId').setValue(this.selectedBranches, { emitEvent: false });
    }
  }

  onBranchSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');
    this.selectedBranches = selected;
    this.FeeDetailForm.get('StrId').setValue(selected, { emitEvent: false });
  }

  isAllBranchesSelected(): boolean {
    return (
      this.selectedBranches.length === this.filteredBranchList.length &&
      this.filteredBranchList.length > 0
    );
  }
  getCollegesForCourses(courseCodes: string[]) {
    if (!courseCodes || courseCodes.length === 0) {
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.selectedColleges = [];
      this.FeeDetailForm.get('CgCode').setValue([]);
      this.clearBranches();
      return;
    }

    this.spinner.show();
    const requests = courseCodes.map((coCode) => {
      const payload = { CoCode: coCode };
      return this.umsService.courseClg(payload).toPromise();
    });

    Promise.all(requests)
      .then((responses) => {
        this.spinner.hide();
        const allColleges: any[] = [];
        responses.forEach((res) => {
          if (res && res.status && res.data) {
            allColleges.push(...res.data);
          }
        });
        const uniqueColleges = allColleges.filter(
          (college, index, self) =>
            index === self.findIndex((c) => c.CgCode === college.CgCode)
        );
        this.collegeList = uniqueColleges;
        this.filteredCollegeList = uniqueColleges.slice();
        this.selectedColleges = [];
        this.FeeDetailForm.get('CgCode').setValue([]);
      })
      .catch((error) => {
        this.spinner.hide();
        this.collegeList = [];
        this.filteredCollegeList = [];
        this.selectedColleges = [];
        this.FeeDetailForm.get('CgCode').setValue([]);
        this.clearBranches();
        let data = {
          message: error.error?.message || 'Failed to fetch colleges',
          title: 'Information',
          icon: 'fas fa-close',
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }

  getExamsForCourses(courseCodes: string[]) {
    if (!courseCodes || courseCodes.length === 0) {
      this.examList = [];
      this.filteredListExam = [];
      this.selectedExams = [];
      this.FeeDetailForm.get('EmId').setValue([]);
      this.clearBranches();
      return;
    }

    this.spinner.show();
    const requests = courseCodes.map((coCode) => {
      const payload = { EmCoCode: coCode };
      return this.umsService.getExam(payload).toPromise();
    });

    Promise.all(requests)
      .then((responses) => {
        this.spinner.hide();
        const allExams: any[] = [];
        responses.forEach((res) => {
          if (res && res.status && res.data) {
            allExams.push(...res.data);
          }
        });
        const uniqueExams = allExams.filter(
          (exam, index, self) =>
            index === self.findIndex((e) => e.EmId === exam.EmId)
        );
        this.examList = uniqueExams;
        this.filteredListExam = uniqueExams.slice();
        this.selectedExams = [];
        this.FeeDetailForm.get('EmId').setValue([]);
        this.clearBranches();
      })
      .catch((error) => {
        this.spinner.hide();
        this.examList = [];
        this.filteredListExam = [];
        this.selectedExams = [];
        this.FeeDetailForm.get('EmId').setValue([]);
        this.clearBranches();
        let data = {
          message: error.error?.message || 'Failed to fetch exams',
          title: 'Alert',
          icon: 'fas fa-close',
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      });
  }

  clearBranches() {
    this.BranchList = [];
    this.filteredBranchList = [];
    this.BranchShow = false;
    this.selectedBranches = [];
    this.FeeDetailForm.patchValue({ StrId: [] });
  }

  getCourseData() {
    this.spinner.show();
    this.umsService.getCourse({}).subscribe(
      (res) => {
        this.spinner.hide();
        this.courseList = res.data;
        this.filteredcourseList = this.courseList.slice();
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.courseList = [];
        let data = {
          message: ERROR.error.message,
          title: 'Information',
          icon: 'fas fa-close',
        };
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    );
  }

  selectAllCourses(): void {
    if (this.isAllCoursesSelected()) {
      this.selectedCourses = [];
      this.FeeDetailForm.get('CoCode').setValue([], { emitEvent: false });
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.selectedColleges = [];
      this.FeeDetailForm.get('CgCode').setValue([]);
      this.clearBranches();
      if (this.ExmList) {
        this.getExamsForCourses([]);
      }
    } else {
      this.selectedCourses = this.filteredcourseList.map((item) => item.CoCode);
      this.FeeDetailForm.get('CoCode').setValue(this.selectedCourses, { emitEvent: false });
      this.getCollegesForCourses(this.selectedCourses);
      if (this.ExmList) {
        this.getExamsForCourses(this.selectedCourses);
      }
    }
  }

  onCourseSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');
    this.selectedCourses = selected;
    this.FeeDetailForm.get('CoCode').setValue(selected, { emitEvent: false });
    if (selected && selected.length > 0) {
      this.getCollegesForCourses(selected);
      if (this.ExmList) {
        this.getExamsForCourses(selected);
      }
    } else {
      this.collegeList = [];
      this.filteredCollegeList = [];
      this.selectedColleges = [];
      this.FeeDetailForm.get('CgCode').setValue([]);
      this.clearBranches();
      if (this.ExmList) {
        this.getExamsForCourses([]);
      }
    }
  }

  isAllCoursesSelected(): boolean {
    return (
      this.selectedCourses.length === this.filteredcourseList.length &&
      this.filteredcourseList.length > 0
    );
  }

  selectAllColleges(): void {
    if (this.isAllCollegesSelected()) {
      this.selectedColleges = [];
      this.FeeDetailForm.get('CgCode').setValue([], { emitEvent: false });
    } else {
      this.selectedColleges = this.filteredCollegeList.map((item) => item.CgCode);
      this.FeeDetailForm.get('CgCode').setValue(this.selectedColleges, { emitEvent: false });
    }
  }

  onCollegeSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');
    this.selectedColleges = selected;
    this.FeeDetailForm.get('CgCode').setValue(selected, { emitEvent: false });
  }

  isAllCollegesSelected(): boolean {
    return (
      this.selectedColleges.length === this.filteredCollegeList.length &&
      this.filteredCollegeList.length > 0
    );
  }

  selectAllExams(): void {
    if (this.isAllExamsSelected()) {
      this.selectedExams = [];
      this.FeeDetailForm.get('EmId').setValue([], { emitEvent: false });
      this.clearBranches();
    } else {
      this.selectedExams = this.filteredListExam.map((item) => item.EmId);
      this.FeeDetailForm.get('EmId').setValue(this.selectedExams, { emitEvent: false });
      this.fetchBranchesForExams(this.selectedExams);
    }
  }

  onExamSelect(event: any): void {
    let selected = event.value ? [...event.value] : [];
    selected = selected.filter((item: any) => item !== 'selectAll');
    this.selectedExams = selected;
    this.FeeDetailForm.get('EmId').setValue(selected, { emitEvent: false });
    if (selected && selected.length > 0) {
      this.fetchBranchesForExams(selected);
    } else {
      this.clearBranches();
    }
  }

  isAllExamsSelected(): boolean {
    return (
      this.selectedExams.length === this.filteredListExam?.length &&
      this.filteredListExam?.length > 0
    );
  }

  getListforExam() {
    if (this.FeeDetailForm.value['FeeType'] == 'AF') {
      this.AdmList = true;
      this.ExmList = false;
      this.clearBranches();
    } else if (this.FeeDetailForm.value['FeeType'] == 'EF') {
      this.AdmList = false;
      this.ExmList = true;
      const courseCodes = this.FeeDetailForm.value['CoCode'] || [];
      if (courseCodes.length > 0) {
        this.getExamsForCourses(courseCodes);
      } else {
        this.examList = [];
        this.filteredListExam = [];
        this.selectedExams = [];
        this.FeeDetailForm.get('EmId').setValue([]);
        this.clearBranches();
      }
    }
  }

  getData() {
    if (this.ExmList == true) {
      this.FeeDetailForm.get('EmId').setValidators([Validators.required]);
      this.FeeDetailForm.get('EmId').updateValueAndValidity();
      this.FeeDetailForm.get('EmId').markAsTouched();
    }

    if (this.FeeDetailForm.invalid) {
      if (this.ExmList == true) {
        this.FeeDetailForm.get('EmId').setValidators([Validators.required]);
        this.FeeDetailForm.get('EmId').updateValueAndValidity();
        this.FeeDetailForm.get('EmId').markAsTouched();
      }
      this.FeeDetailForm.get('FeeType').markAsTouched();
      this.FeeDetailForm.get('SnNo').markAsTouched();
      return;
    }

    this.spinner.show();

    let pendingCalls = 0;

    const onComplete = () => {
      pendingCalls--;
      if (pendingCalls === 0) {
        this.spinner.hide();
      }
    };

    const onError = (err: any, message?: string) => {
      pendingCalls--;
      if (pendingCalls === 0) {
        this.spinner.hide();
      }
      this.showErrorPopup(message || err?.error?.message || 'An error occurred');
    };
    pendingCalls++;
    this.getList(onComplete, onError);

    pendingCalls++;
    this.unpaidFeeReport(onComplete, onError);
  }
  getList(onComplete: () => void, onError: (err: any, msg?: string) => void) {
    if (this.FeeDetailForm.value['FeeType'] == 'AF') {
      this.getAdmList(onComplete, onError);
    } else if (this.FeeDetailForm.value['FeeType'] == 'EF') {
      this.getExmList(onComplete, onError);
    } else {
      onComplete();
    }
  }

  getExmList(onComplete: () => void, onError: (err: any, msg?: string) => void) {
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    const cgCode = Array.isArray(submitpayload.CgCode)
      ? submitpayload.CgCode.join(',')
      : submitpayload.CgCode;
    const coCode = Array.isArray(submitpayload.CoCode)
      ? submitpayload.CoCode.join(',')
      : submitpayload.CoCode;
    const emId = Array.isArray(submitpayload.EmId)
      ? submitpayload.EmId.join(',')
      : submitpayload.EmId;
    const strId = this.selectedBranches.length ? this.selectedBranches.join(',') : '';

    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = cgCode;
    payload['CoCode'] = coCode;
    payload['StuId'] = 0;
    payload['EmId'] = emId;
    payload['StrId'] = strId;

    payload2['SessionId'] = submitpayload.SnNo;
    payload2['CoCode'] = coCode;
    payload2['CgCode'] = cgCode;
    payload2['StuId'] = 0;
    payload2['FeeType'] = 'EF';
    payload2['EmId'] = emId;
    payload2['StrId'] = strId;

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          // this.Table = true;
          // spinner.hide()
          const paidFeeData = res.data;
          const firstItem = paidFeeData[0];
          this.heads = Object.keys(firstItem)
            .filter((k) => k.startsWith('Head') && k.endsWith('Name'))
            .sort((a, b) => {
              const numA = parseInt(a.match(/\d+/)[0], 10);
              const numB = parseInt(b.match(/\d+/)[0], 10);
              return numA - numB;
            })
            .map((k) => {
              const num = k.match(/\d+/)[0];
              return { name: firstItem[k], amtKey: `Head${num}Amt` };
            });

          console.log(this.heads);
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];
          this.PaidCount = res.data[0]['PaidCount'];

          const paidStuIds = new Set(paidFeeData.map((item) => item.StuId));

          // Call the second API for unpaid fees
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {

                const studentData = unpaidRes.data;
                const filteredUnpaidData = studentData.filter((record) => !paidStuIds.has(record.StuId));
                const studentMap = new Map<number, any>();
                filteredUnpaidData.forEach((record) => {
                  const key = record.StuId;
                  if (!studentMap.has(key)) {
                    studentMap.set(key, record);
                  }
                });
                const FeeData = Array.from(studentMap.values()).map((item) => {
                  return {
                    ...item,  // preserves 'Cap fee' and 'Exam Fee' keys
                    FeeAmt: '-',
                    TotalPaidAmount: item.TotalPaidAmount || 0,
                    FeeTemplateCode: '-',
                  };
                });
                this.FeeData = [...paidFeeData, ...FeeData];
                this.Table = true;
                onComplete(); 
              } else {
                this.FeeData = [...paidFeeData];
                this.Table = true;
                onComplete();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              onError(error, error.error?.message || 'Failed to fetch unpaid fee details');
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {

                const studentData = unpaidRes.data;
                const studentMap = new Map<number, any>();
                studentData.forEach(record => {
                  const key = record.StuId;
                  if (!studentMap.has(key)) {
                    studentMap.set(key, record);
                  }
                });
                const FeeData = Array.from(studentMap.values()).map((item) => {
                  return {
                    ...item,  // preserves 'Cap fee' and 'Exam Fee'
                    FeeAmt: '-',
                    TotalPaidAmount: item.TotalPaidAmount || 0,
                    FeeTemplateCode: item.TemplateCode || '-',
                  };
                });
                this.FeeData = [...FeeData];
                // this.TotalPaid = this.calculateTotalPaidAmount(this.FeeData);
                this.Table = true;
                onComplete();
              } else {
                this.Table = false;
                this.showNoDataFound();
                onComplete();
              }
            },
            (error: HttpErrorResponse) => {
              this.spinner.hide();
              this.Table = false;
              onError(error, error.error?.message || 'Failed to fetch fee details');
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.Table = false;
        onError(error, error.error?.message || 'Failed to fetch fee details');
      }
    );
  }

  calculateTotalPaidAmount(data: any[]): number {
    return data.reduce((sum, item) => {
      const amount = typeof item.TotalPaidAmount === 'number' ? item.TotalPaidAmount : 0;
      return sum + amount;
    }, 0);
  }

  getAdmList(onComplete: () => void, onError: (err: any, msg?: string) => void) {
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    const cgCode = Array.isArray(submitpayload.CgCode)
      ? submitpayload.CgCode.join(',')
      : submitpayload.CgCode;
    const coCode = Array.isArray(submitpayload.CoCode)
      ? submitpayload.CoCode.join(',')
      : submitpayload.CoCode;
    const strId = this.selectedBranches.length ? this.selectedBranches.join(',') : '';

    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = cgCode;
    payload['CoCode'] = coCode;
    payload['StuId'] = 0;
    payload['StrId'] = strId;

    payload2['FeeType'] = submitpayload.FeeType;
    payload2['SnNo'] = submitpayload.SnNo;
    payload2['CgCode'] = cgCode;
    payload2['CoCode'] = coCode;
    payload2['StrId'] = strId;

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          // spinner.hide() removed - handled by parent
          this.Table = true;
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];

          // Call the second API for unpaid fees
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });

                // Combine the data from both APIs
                this.FeeData = [...paidFeeData, ...unpaidFeeData];
                this.Table = true;
                onComplete(); // Both APIs done
              } else {
                this.FeeData = [...paidFeeData];
                this.Table = true;
                onComplete();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              onError(error, error.error?.message || 'Failed to fetch unpaid fee report');
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });

                // Combine the data from both APIs
                this.FeeData = [...unpaidFeeData];
                this.Table = true;
                onComplete();
              } else {
                this.Table = false;
                this.spinner.hide();
                this.showNoDataFound();
                onComplete();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              onError(error, error.error?.message || 'Failed to fetch unpaid fee report');
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.Table = false;
        onError(error, error.error?.message || 'Failed to fetch fee details');
      }
    );
  }

  showNoDataFound() {
    let data = {};
    this.TotalFees = 0;
    this.TotalPaid = 0;
    data['message'] = 'No Data Found';
    data['title'] = 'Information';
    data['icon'] = 'fas fa-box-open';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  showErrorPopup(message: string) {
    let data = {};
    data['message'] = message;
    data['title'] = 'Information';
    data['icon'] = 'fas fa-box-open';
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  back() {
    this.ngOnInit();
  }

  Back1() {
    this.goBack();
  }
  goBack(): void {
    this.location.back();
  }
  getSessionName(snNo: any): string {
    const session = this.sessionList.find(s => s.SnNo == snNo);
    return session ? session.SnName : snNo;
  }

  getBranchName(strId: any): string {
    if (!strId) return '';
    const branch = this.BranchList.find(b => b.StrId == strId);
    return branch ? branch.StrName : strId;
  }

  unpaidFeeReport(onComplete: () => void, onError: (err: any, msg?: string) => void) {
    this.FeeData = [];
    const payload = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    const cgCode = Array.isArray(submitpayload.CgCode)
      ? submitpayload.CgCode.join(',')
      : submitpayload.CgCode;
    const coCode = Array.isArray(submitpayload.CoCode)
      ? submitpayload.CoCode.join(',')
      : submitpayload.CoCode;

    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = cgCode;
    payload['CoCode'] = coCode;
    this.umsService.unpaidFeeReport(payload).subscribe(
      (res) => {
        if (res.status) {
          // Do something if needed
        }
        onComplete();
      },
      (ERROR: HttpErrorResponse) => {
        this.Table = false;
        onError(ERROR, ERROR.error?.message || 'Failed to fetch unpaid fee report (third call)');
      }
    );
  }

  download3(event: Event) {
    event.preventDefault();
    const payload = {};
    // payload['EcId'] = this.marksEntryForm.value['list'];

    if (this.FeeDetailForm.value['FeeType'] == 'AF') {
      this.getAdmListDownload();
    } else if (this.FeeDetailForm.value['FeeType'] == 'EF') {
      this.getExmListDownload();
    }
  }

  convertArrayToCSV(array: any[]): string {
  if (!array || array.length === 0) return '';

  const header = Object.keys(array[0]).join(',');
  const rows = array.map((obj) =>
    Object.values(obj)
      .map((value) => {
        const stringValue = String(value);

        if (/^0\d+$/.test(stringValue)) {
          return `"=""${stringValue}"""`;
        }
        return `"${stringValue}"`;
      })
      .join(',')
  );

  return [header, ...rows].join('\n');
}

  getAdmListDownload() {
    this.spinner.show();
    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    const cgCode = Array.isArray(submitpayload.CgCode)
      ? submitpayload.CgCode.join(',')
      : submitpayload.CgCode;
    const coCode = Array.isArray(submitpayload.CoCode)
      ? submitpayload.CoCode.join(',')
      : submitpayload.CoCode;
    const strId = this.selectedBranches.length ? this.selectedBranches.join(',') : '';

    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = cgCode;
    payload['CoCode'] = coCode;
    payload['StuId'] = 0;
    payload['StrId'] = strId;

    payload2['FeeType'] = submitpayload.FeeType;
    payload2['SnNo'] = submitpayload.SnNo;
    payload2['CgCode'] = cgCode;
    payload2['CoCode'] = coCode;
    payload2['StrId'] = strId;

    const session = this.sessionList.find(s => s.SnNo == this.FeeDetailForm.value.SnNo);
    const sessionName = session ? session.SnName : '';

    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.Table = true;
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];

          const extractedData = res.data.map((element) => ({
            Session: sessionName,
            FeeTemplateCode: element.FeeTemplateCode,
            StudentId: element.StuId,
            StudentName:
              element.StuFirstNameEng +
              ' ' +
              element.StuMidNameEng +
              ' ' +
              element.StuLastNameEng,
            TotalFee: element.FeeAmt,
            PaidAmount: element.TotalPaidAmount,
            College: element.CgName,
            Course: element.CoName,
            Branch: this.getBranchName(element.StrId), // FIXED
          }));

          const csvContent = this.convertArrayToCSV(extractedData);
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'paidData.csv';
          document.body.appendChild(link);

          // Trigger the download
          link.click();

          // Call the second API for unpaid fees
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });
                const extractedUnpaidData = unpaidRes.data.map((element) => ({
                  Session: sessionName,
                  StudentRgNo: element.RgNo,
                  StudentName:
                    element.StuFirstNameEng +
                    ' ' +
                    element.StuMidNameEng +
                    ' ' +
                    element.StuLastNameEng,
                  College: element.CgName,
                  Course: element.CoCode,
                  Branch: this.getBranchName(element.StrId), // FIXED
                  FeeTemplateCode: '-',
                  TotalFee: '-',
                  PaidAmount: '0',
                }));
                // Convert array data to CSV format for unpaid fee data
                const unpaidCsvContent = this.convertArrayToCSV(extractedUnpaidData);
                const unpaidBlob = new Blob([unpaidCsvContent], {
                  type: 'text/csv;charset=utf-8;',
                });
                const unpaidUrl = window.URL.createObjectURL(unpaidBlob);
                const unpaidLink = document.createElement('a');
                unpaidLink.href = unpaidUrl;
                unpaidLink.download = 'unpaid_data.csv';
                document.body.appendChild(unpaidLink);
                unpaidLink.click();

                // Combine the data from both APIs

                this.FeeData = [...paidFeeData, ...unpaidFeeData];
                this.Table = true;
                this.spinner.hide();
              } else {
                this.FeeData = [...paidFeeData];
                this.Table = true;
                this.spinner.hide();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              this.spinner.hide();
              this.showErrorPopup(error.error.message);
            }
          );
        } else {
          // this.Table = false;
          // this.showNoDataFound();
          this.umsService.unpaidFeeReport(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const unpaidFeeData = unpaidRes.data.map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                  };
                });
                const extractedUnpaidData = unpaidRes.data.map((element) => ({
                  Session: sessionName,
                  StudentRgNo: element.RgNo,
                  StudentName:
                    element.StuFirstNameEng +
                    ' ' +
                    element.StuMidNameEng +
                    ' ' +
                    element.StuLastNameEng,
                  College: element.CgName,
                  Course: element.CoCode,
                  Branch: this.getBranchName(element.StrId), // FIXED
                  TotalFee: '-',
                  PaidAmount: '0',
                  FeeTemplateCode: '-',

                }));
                // Convert array data to CSV format for unpaid fee data
                const unpaidCsvContent = this.convertArrayToCSV(extractedUnpaidData);
                const unpaidBlob = new Blob([unpaidCsvContent], {
                  type: 'text/csv;charset=utf-8;',
                });
                const unpaidUrl = window.URL.createObjectURL(unpaidBlob);
                const unpaidLink = document.createElement('a');
                unpaidLink.href = unpaidUrl;
                unpaidLink.download = 'unpaid_data.csv';
                document.body.appendChild(unpaidLink);
                unpaidLink.click();


                // Combine the data from both APIs
                this.FeeData = [...unpaidFeeData];
                this.Table = true;
                this.spinner.hide();
              } else {
                this.Table = false;
                this.spinner.hide();
                this.showNoDataFound();
              }
            },
            (error: HttpErrorResponse) => {
              this.Table = false;
              this.spinner.hide();
              this.showErrorPopup(error.error.message);
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.Table = false;
        this.spinner.hide();
        this.showErrorPopup(error.error.message);
      }
    );
  }



  getExmListDownload() {
    // Show spinner once
    this.spinner.show();

    this.FeeData = [];
    const payload = {};
    const payload2 = {};
    this.Table = false;
    this.TotalFees = 0;
    this.TotalPaid = 0;
    let submitpayload = this.FeeDetailForm.value;
    const cgCode = Array.isArray(submitpayload.CgCode)
      ? submitpayload.CgCode.join(',')
      : submitpayload.CgCode;
    const coCode = Array.isArray(submitpayload.CoCode)
      ? submitpayload.CoCode.join(',')
      : submitpayload.CoCode;
    const emId = Array.isArray(submitpayload.EmId)
      ? submitpayload.EmId.join(',')
      : submitpayload.EmId;
    const strId = this.selectedBranches.length ? this.selectedBranches.join(',') : '';

    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['CgCode'] = cgCode;
    payload['CoCode'] = coCode;
    payload['StuId'] = 0;
    payload['EmId'] = emId;
    payload['StrId'] = strId;

    payload2['SessionId'] = submitpayload.SnNo;
    payload2['CoCode'] = coCode;
    payload2['CgCode'] = cgCode;
    payload2['StuId'] = 0;
    payload2['FeeType'] = 'EF';
    payload2['EmId'] = emId;
    payload2['StrId'] = strId;

    const session = this.sessionList.find(s => s.SnNo == this.FeeDetailForm.value.SnNo);
    const sessionName = session ? session.SnName : '';
    // Helper to hide spinner once all work is done
    const finalize = () => {
      this.spinner.hide();
    };

    // Call the first API for paid fees
    this.umsService.FeeDetails(payload).subscribe(
      (res) => {
        if (res.status) {
          const paidFeeData = res.data;
          this.TotalFees = res.data[0]['TotFeeAmt'];
          this.TotalPaid = res.data[0]['TotPaidAmt'];

          const extractedData = res.data.map((element) => {
            const headData = {};
            this.heads.forEach((head) => {
              headData[head.name] = element[head.amtKey];
            });
            return {
              Session: sessionName,
              StudentId: element.StuId,
              PrnNo: element.StuRgNo,
              StudentName:
                element.StuFirstNameEng +
                ' ' +
                element.StuMidNameEng +
                ' ' +
                element.StuLastNameEng,
              College: element.CgName,
              Course: element.CoName,
              Branch: this.getBranchName(element.StrId), // FIXED
              Exam: element.EmName,
              TotalFee: element.FeeAmt,
              ...headData,
              'Cap fee': element['Cap fee'] || 0,
              'Exam Fee': element['Exam Fee'] || 0,
              'Degree Certificate/Provisional Degree Certificate': element['Degree Certificate/Provisional Degree Certificate'] || 0,
              'Provisional Degree Certificate': element['Provisional Degree Certificate'] || 0,
              'Passing Certificate': element['Passing Certificate'] || 0,
              PaidAmount: element.TotalPaidAmount,
              FeeTemplateCode: element.FeeTemplateCode,
              TransactionId: `\t${element.TransactionId}`,
              ReceiptNo_UMS: element.PaymentresponseID,
              ReceiptNo_Unisuite: element.receiptNo,
              ReceiptDate: element.PaymentDate,
              RollNo: element.RollNo || element.SeatNo || '-',
            };
          });
          // Convert array data to CSV format
          const csvContent = this.convertArrayToCSV(extractedData);
          const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'paidDataExam.csv';
          document.body.appendChild(link);
          link.click();

          const paidStuIds = new Set(paidFeeData.map(item => item.StuId));

          // Call the second API for unpaid fees
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const studentData = unpaidRes.data;
                const filteredUnpaidData = studentData.filter(record => !paidStuIds.has(record.StuId));
                const studentMap = new Map<number, any>();
                filteredUnpaidData.forEach((record) => {
                  const key = record.StuId;
                  if (!studentMap.has(key)) {
                    studentMap.set(key, record);
                  }
                });
                const FeeData = Array.from(studentMap.values()).map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: item.TotalPaidAmount || 0,
                    FeeTemplateCode: '-',
                  };
                });
                this.FeeData = [...paidFeeData, ...FeeData];
                this.Table = true;

                const extractedUnpaidData = Array.from(studentMap.values()).map(
                  (element) => ({
                    Session: sessionName,
                    StudentId: element.StuId,
                    StudentName:
                      element.StuFirstNameEng +
                      ' ' +
                      element.StuMidNameEng +
                      ' ' +
                      element.StuLastNameEng,
                    College: element.CgCode,
                    Course: element.CoCode,
                    Branch: this.getBranchName(element.StrId), // FIXED
                    FeeAmount: element.FeeAmount,
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                    'Cap fee': element['Cap fee'] || 0,
                    'Exam Fee': element['Exam Fee'] || 0,
                    'Degree Certificate/Provisional Degree Certificate': element['Degree Certificate/Provisional Degree Certificate'] || 0,
                    'Provisional Degree Certificate': element['Provisional Degree Certificate'] || 0,
                    'Passing Certificate': element['Passing Certificate'] || 0,
                    RollNo: element.RollNo || element.SeatNo || '-',
                  })
                );

                const csvUnpaidContent = this.convertArrayToCSV(extractedUnpaidData);
                const blob = new Blob([csvUnpaidContent], {
                  type: 'text/csv;charset=utf-8;',
                });
                const url = window.URL.createObjectURL(blob);
                const unpaidLink = document.createElement('a');
                unpaidLink.href = url;
                unpaidLink.download = 'unpaidDataExam.csv';
                document.body.appendChild(unpaidLink);
                unpaidLink.click();
              } else {
                this.FeeData = [...paidFeeData];
                this.Table = true;
              }
              // Both APIs done – hide spinner
              finalize();
            },
            (error: HttpErrorResponse) => {
              // Second API error – hide spinner and show error
              this.spinner.hide();
              this.Table = false;
              this.showErrorPopup(error.error.message);
            }
          );
        } else {
          // First API returned false – fallback to second API only
          this.umsService.getFeeDetails(payload2).subscribe(
            (unpaidRes) => {
              if (unpaidRes.status) {
                const studentData = unpaidRes.data;
                const studentMap = new Map<number, any>();
                studentData.forEach((record) => {
                  const key = record.StuId;
                  if (!studentMap.has(key)) {
                    studentMap.set(key, record);
                  }
                });
                const FeeData = Array.from(studentMap.values()).map((item) => {
                  return {
                    ...item,
                    FeeAmt: '-',
                    TotalPaidAmount: item.TotalPaidAmount || 0,
                    FeeTemplateCode: item.TemplateCode || '-',
                  };
                });
                this.FeeData = [...FeeData];
                this.Table = true;

                const extractedUnpaidData = Array.from(studentMap.values()).map(
                  (element) => ({
                    Session: sessionName,
                    StudentId: element.StuId,
                    StudentName:
                      element.StuFirstNameEng +
                      ' ' +
                      element.StuMidNameEng +
                      ' ' +
                      element.StuLastNameEng,
                    College: element.CgCode,
                    Course: element.CoCode,
                    Branch: this.getBranchName(element.StrId), // FIXED
                    FeeAmount: element.FeeAmount,
                    TotalPaidAmount: 0,
                    FeeTemplateCode: '-',
                    'Cap fee': element['Cap fee'] || 0,
                    'Exam Fee': element['Exam Fee'] || 0,
                    'Degree Certificate/Provisional Degree Certificate': element['Degree Certificate/Provisional Degree Certificate'] || 0,
                    'Provisional Degree Certificate': element['Provisional Degree Certificate'] || 0,
                    'Passing Certificate': element['Passing Certificate'] || 0,
                    RollNo: element.RollNo || element.SeatNo || '-',
                  })
                );

                const csvUnpaidContent = this.convertArrayToCSV(extractedUnpaidData);
                const blob = new Blob([csvUnpaidContent], {
                  type: 'text/csv;charset=utf-8;',
                });
                const url = window.URL.createObjectURL(blob);
                const unpaidLink = document.createElement('a');
                unpaidLink.href = url;
                unpaidLink.download = 'unpaidDataExam.csv';
                document.body.appendChild(unpaidLink);
                unpaidLink.click();
              } else {
                this.Table = false;
                this.showNoDataFound();
              }
              // Fallback done – hide spinner
              finalize();
            },
            (error: HttpErrorResponse) => {
              this.spinner.hide();
              this.Table = false;
              this.showErrorPopup(error.error.message);
            }
          );
        }
      },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.Table = false;
        this.showErrorPopup(error.error.message);
      }
    );

  }
}
